import { csrfToken } from "../../core/http";
import { localizedRawPath } from "../../core/localePaths";

export async function signOutSession() {
  const response = await fetch(localizedRawPath("/logout"), {
    method: "DELETE",
    headers: {
      "X-CSRF-Token": csrfToken(),
      Accept: "application/json",
    },
    credentials: "same-origin",
  });
  if (!response.ok) throw new Error("Sign out failed");
}
